import { axios } from "..";

export const getUsers = async () => {
  try {
    const users = await axios.Get("./user");
    const data = users.data;
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};

export const createUser = async (user: any) => {
  const newUser = await axios.Post("./user", user);
  return newUser.data;
}

export const getUserByFirm = async (userId: string) => {
  const user = await axios.Get(`./user?id=${userId}`);
  return user.data;
}